/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The WasterecordQueryResult model module.
 * @module model/WasterecordQueryResult
 * @version 1.0
 */
class WasterecordQueryResult {
    /**
     * Constructs a new <code>WasterecordQueryResult</code>.
     * @alias module:model/WasterecordQueryResult
     */
    constructor() { 
        
        WasterecordQueryResult.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WasterecordQueryResult</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WasterecordQueryResult} obj Optional instance to populate.
     * @return {module:model/WasterecordQueryResult} The populated <code>WasterecordQueryResult</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WasterecordQueryResult();

            if (data.hasOwnProperty('bagType')) {
                obj['bagType'] = ApiClient.convertToType(data['bagType'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('metal')) {
                obj['metal'] = ApiClient.convertToType(data['metal'], 'Number');
            }
            if (data.hasOwnProperty('paper')) {
                obj['paper'] = ApiClient.convertToType(data['paper'], 'Number');
            }
            if (data.hasOwnProperty('plastic')) {
                obj['plastic'] = ApiClient.convertToType(data['plastic'], 'Number');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
            if (data.hasOwnProperty('waste')) {
                obj['waste'] = ApiClient.convertToType(data['waste'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} bagType
 */
WasterecordQueryResult.prototype['bagType'] = undefined;

/**
 * @member {String} createdAt
 */
WasterecordQueryResult.prototype['createdAt'] = undefined;

/**
 * @member {String} date
 */
WasterecordQueryResult.prototype['date'] = undefined;

/**
 * @member {String} deletedAt
 */
WasterecordQueryResult.prototype['deletedAt'] = undefined;

/**
 * @member {Number} id
 */
WasterecordQueryResult.prototype['id'] = undefined;

/**
 * @member {Number} metal
 */
WasterecordQueryResult.prototype['metal'] = undefined;

/**
 * @member {Number} paper
 */
WasterecordQueryResult.prototype['paper'] = undefined;

/**
 * @member {Number} plastic
 */
WasterecordQueryResult.prototype['plastic'] = undefined;

/**
 * @member {String} updatedAt
 */
WasterecordQueryResult.prototype['updatedAt'] = undefined;

/**
 * @member {Number} userId
 */
WasterecordQueryResult.prototype['userId'] = undefined;

/**
 * @member {Number} waste
 */
WasterecordQueryResult.prototype['waste'] = undefined;






export default WasterecordQueryResult;

